/**
 * Mount full-screen HTML overlays inside #app-shell so they cover the Phaser play area.
 * See `.cursor/rules/game-viewport-layout.mdc` before changing mount list or classes.
 */

const IN_GAME_OVERLAY_IDS = [
  "game-loading-overlay",
  "journal-overlay",
  "radio-overlay",
  "narrative-overlay",
  "accusation-vote-overlay",
  "accusation-arrest-overlay",
  "outcome-overlay",
  "player-manual-overlay",
  "follow-confirm-overlay",
  "zone-transit-confirm-overlay",
] as const;

const mounted = new Map<string, { parent: HTMLElement; next: ChildNode | null }>();

export function mountInGameOverlaysToShell(shell: HTMLElement): void {
  for (const id of IN_GAME_OVERLAY_IDS) {
    const overlay = document.getElementById(id);
    if (!overlay || mounted.has(id)) continue;
    mounted.set(id, { parent: overlay.parentElement!, next: overlay.nextSibling });
    overlay.classList.remove("ccc-vv-bound");
    overlay.classList.add("ccc-vv-in-shell");
    shell.appendChild(overlay);
  }
}

export function unmountInGameOverlaysFromShell(): void {
  for (const id of IN_GAME_OVERLAY_IDS) {
    const overlay = document.getElementById(id);
    const prev = mounted.get(id);
    if (!overlay || !prev) continue;
    overlay.classList.remove("ccc-vv-in-shell");
    overlay.classList.add("ccc-vv-bound");
    if (prev.next) prev.parent.insertBefore(overlay, prev.next);
    else prev.parent.appendChild(overlay);
    mounted.delete(id);
  }
}
